import type { Theme } from '@mui/material';
import theme from 'providers/theme/theme';
import type { StyleExtend } from 'providers/theme/theme.types';

export const FullscreenLoaderTextStyle: StyleExtend<Theme> = {
  fontSize: '18px',
  textShadow: '1px 1px 3px #000',
  mt: 2,
  ...theme.mixins.textOverflowStyle(),

  '&:after': {
    position: 'absolute',
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom',
    WebkitAnimation: 'ellipsis steps(4,end) 900ms infinite',
    animation: 'ellipsis steps(4,end) 900ms infinite',
    content: '"\\2026"',
    width: '0px',
  },

  '@keyframes ellipsis': {
    to: {
      width: '15px',
    },
  },
};
